export class DataView {
  public DataViewId: number;
  public DefaultView: number;
  public Descr: string;
  public Path: string;
  public SQLText: string;
  public SearchParamDto: string;
  public Version: number;
  public AllUsers: boolean;

  public constructor() {
    this.DataViewId = 0;
    this.DefaultView = 0;
    this.Descr = '';
    this.Path = '';
    this.SQLText = '';
    this.SearchParamDto = '';
    this.Version = 2;
  }
}
